import React from "react";
import { useTranslation } from "react-i18next";

import { useEditEvent } from "@planzone/view-models";
import { Props } from "./types";
import { NameForm } from "./nameForm";
import { RichTextInput } from "@common/richTextInput";
import styles from "./styles.scss";

function Details({ event, error, readOnly }: Props) {
  const { t } = useTranslation();
  const [description, setDescription] = React.useState(event.description);
  const { isRequestPending, editEvent } = useEditEvent(event);
  const [isEditable, setIsEditable] = React.useState(false);
  const toggleTitleModification = () => setIsEditable(!isEditable);

  return (
    <div className={styles.details}>
      {!readOnly && isEditable ? (
        <NameForm
          event={event}
          isInvalid={error.emptyName || error.duplicateName}
          hide={toggleTitleModification}
        />
      ) : (
        <h1 className={styles.name} onClick={toggleTitleModification}>
          {event.name}
        </h1>
      )}
      <div className={styles.description}>
        <h3 className={styles.label}>{t("retrieveEvent.description")}</h3>
        <RichTextInput
          value={description || ""}
          maxLength={10000}
          placeholder={t("retrieveEvent.description")}
          input={setDescription}
          onChange={() =>
            !isRequestPending &&
            editEvent({
              event,
              nextEvent: { ...event, description },
            })
          }
          isDisabled={readOnly}
        />
      </div>
    </div>
  );
}

export { Details };
